<template>
  <div>
    <HeadNav selectedLanguage="en" page="blog1" :gotodownload="gotodownload" :apk="apk" />
    <div class="breadcrumb-blog1">
      <BreadCrumb :breadcrumbs="breadcrumbs" />
    </div>
    <div id="page" class="site grid-container container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <section id="section-1" class="section-content">
              <h1 class="section-1-blog-head">
                Advanced Customization Options in GB WhatsApp
              </h1>

              <div class="lazy-picture-container writer-banner width-75" style="text-align: center;">
                <picture><img width="auto" height="auto" alt="Advanced Customization Options in GB WhatsApp"
                    src="../assets/blog-5.webp">
                </picture>
              </div>
              <p class="writter-content">
                In a world where personalization matters, messaging apps are no exception. Users are no longer satisfied
                with default interfaces and limited features. That’s where <a href="https://gbappslive.com/">GB
                  WhatsApp</a> comes into play—offering a
                treasure trove of <strong>advanced customization options</strong> that go far beyond the standard
                WhatsApp experience.
                Whether you're looking to change the look and feel or gain greater control over your privacy, GB
                WhatsApp empowers users with tools to tailor the app to their needs.
              </p>
              <!-- <div class="is-vertical is-content-justification-center is-layout-flex wp-container-9 wp-block-buttons">
              <div class="wp-block-button">
                <a id="dl" class="wp-block-button__link wp-element-button" target="_blank" rel="dl noopener" @click="gotodownload()">Download GB WhatsApp</a>
              </div>
            </div> -->
              <h2 class="intro-title blog">
                Revamp Your Interface with GB WhatsApp Custom Themes
              </h2>
              <p class="writter-content">
                One of the most appreciated <strong>advanced customization options in GB WhatsApp</strong> is the
                ability to fully redesign your interface. Unlike the original WhatsApp, GB WhatsApp provides access to
                thousands of <strong>custom themes,</strong> each with different color palettes, icon styles, and UI
                tweaks. <br>
                You can either download community-created themes or design your own with just a few taps. This feature
                lets you move away from the monotonous green and white look and personalize your app to match your style
                or mood.
              </p>

              <h2 class="intro-title blog">
                Fine-Tune Conversations Using Advanced Chat Settings
              </h2>
              <p class="writter-content">
                Want to change how individual chats behave? GB WhatsApp offers <strong>chat customization
                  features</strong> that let you
                alter fonts, bubble styles, and even background images for specific contacts. You can assign unique
                styles to each chat window, making it easier to identify your contacts at a glance. <br>

                Additionally, features like message scheduler, auto-reply, and pinning more than three chats help
                streamline communication for both personal and professional use.
              </p>
              <!--  -->
              <!-- <div class="lazy-picture-container writer-banner width-75" style="text-align: center;">
                <picture><img width="auto" height="auto" alt="what is GB WhatsApp" src="../assets/gb-seething.webp">
                </picture>
              </div>
              </p> -->
              <!--  -->

              <h2 class="intro-title blog">
                Privacy First: Unlock Powerful Privacy Customization Tools
              </h2>
              <p class="writter-content">
                Standard WhatsApp offers basic privacy settings, but GB WhatsApp takes things to the next level. You can
                <strong>hide your online status, disable read receipts,</strong> and even <strong>freeze your
                  last</strong> seen without affecting what
                you see from others. <br>
                More advanced options include hiding “typing” and “recording” indicators or viewing deleted messages.
                These features give users full control over how they appear online, a big leap from the limitations of
                the original app.
              </p>
              <h2 class="intro-title blog">Notification Controls and Widget Customization in GB WhatsApp</h2>
              <p class="writter-content">
                Beyond the chat screen, GB WhatsApp allows users to customize notifications and widgets for a more
                seamless experience. You can assign specific tones for different contacts, modify the way pop-up
                notifications appear, or hide them altogether. <br>
                Widget customization lets you add quick-access panels to your home screen, styled to match your theme.
                This makes it not only functional but visually appealing.
              </p>
              <h2 class="intro-title blog">Developer-Like Features: Dive Deeper with GB WhatsApp’s Advanced Settings
              </h2>
              <p class="writter-content">
                For power users, GB WhatsApp includes <strong>developer-level customization options.</strong> From
                enabling anti-revoke
                to customizing backup behaviors and enabling third-party plugins, these features are designed for those
                who want full control. <br>
                You can also change media-sharing limits, such as sending videos up to 700MB, which is impossible in
                standard WhatsApp. These tweaks turn GB WhatsApp into a more flexible, capable messaging platform.
              </p>

              <h2 class="intro-title blog">FAQs</h2>
              <h3>Q1: Is it safe to use GB WhatsApp with all these advanced customization features?</h3>
              <p>
                While GB WhatsApp offers powerful tools, it’s a modded version of WhatsApp and is not officially
                supported by WhatsApp Inc. Use with caution and consider using secondary accounts.
              </p>
              <h3>Q2: Can I restore my chats when switching from WhatsApp to GB WhatsApp?</h3>
              <p>
                Yes, you can back up your chats from original WhatsApp and restore them in GB WhatsApp during setup.
                Always back up locally for a smooth transition.
              </p>
              <h3>
                Q3: Will these customizations affect performance or battery life?
              </h3>
              <p>
                Heavy custom themes or background processes like auto-replies can use more resources. To optimize
                performance, use lightweight themes and limit background features.
              </p>
              <h2 class="intro-title blog">Final Thoughts</h2>
              <p class="writter-content">
                <strong>GB WhatsApp</strong> redefines what it means to personalize your messaging experience. Its
                <strong>advanced customization options</strong> cater to every type of user—whether you're focused on
                aesthetics, privacy, or functionality. While it offers a rich set of tools, remember that GB WhatsApp is
                not an official app, and usage carries certain risks. That said, for users who crave control and
                uniqueness, GB WhatsApp is a powerful alternative worth exploring.
              </p>
              <Carousel />
            </section>

          </main>
        </div>
      </div>
    </div>

    <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
      Download GBWhatsapp APK
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import HeadNav from '@/components/HeadNav.vue';
import BreadCrumb from '@/components/BreadCrumb.vue';
import Carousel from '@/components/Carousel.vue';
import doc from '@/documents/blogs.js';
export default {
  name: 'Home',
  components: {
    HeadNav,
    BreadCrumb,
    Carousel,
  },
  data() {
    return {
      pageName: 'home',
      selectedLanguage: 'en',
      doc: doc,
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
      relatedPosts: [
        {
          image: require('@/assets/uninstall-gbwhatsapp.webp'),
          title: 'Related Post Title 1',
          description: 'Brief description of the related post. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        },
        {
          image: require('@/assets/uninstall-gbwhatsapp.webp'),
          title: 'Related Post Title 2',
          description: 'Brief description of the related post. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return this.$route.matched.reduce((acc, route) => {
        const crumbs = route.meta.breadcrumb || [];
        return acc.concat(crumbs);
      }, []);
    }
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {

    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    jump(url) {
      window.location.href = url;
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>
<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100% !default;

.blog1-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  /* 小屏幕左右边距 */
}

.main-content {
  flex: 2;
  margin-right: 30px;
  background: #f7f7f7;
  padding: 20px;
  border-radius: 10px;
}

.related-posts {
  flex: 1;
  /* 占1/3宽度 */
}

.blog1-container {
  display: flex;
  gap: 30px;
  /* 列间距 */
  margin-top: 40px;
}

/* 文章主体样式 */
.blog-title {
  font-size: 2.5rem;
  margin-bottom: 15px;
  line-height: 1.2;
  font-weight: 700;
}

.author-info {
  display: flex;
  gap: 15px;
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 20px;
}

.download-btn {
  padding: 20px;
  background-color: #025cd8;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 15px 0;
  font-size: 20px;
  display: inline-block;
}

.content-divider {
  border: 0;
  height: 1px;
  background-color: #eee;
  margin: 30px 0;
}

.article-content {
  line-height: 1.6;
  font-size: 1.05rem;
}

/* 相关文章样式 */
/* 优化后的相关文章样式 */
.related-post-item {
  display: flex;
  gap: 20px;
  padding: 15px 0;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

.related-post-thumb {
  /* width: 100px; */
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}

.related-post-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.related-post-title {
  font-size: 1.1rem;
  margin-bottom: 8px;
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.related-post-desc {
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.related-post-divider {
  border: 0;
  border-top: 1px solid #eee;
  margin: 0;
}

.author {
  display: flex;
  /* padding: 40px; */
  max-width: 1000px;
  gap: 30px;
  margin: 30px auto;
  background: #f2fff6;
  border-radius: 12px;
  box-shadow: 0 2px 5px #ccc;
  /* align-items: center; */
}

.author-avatar {
  border-radius: 12px 0 0 12px;
  height: 100%;
}

.author-right-info {
  flex: 1;
  padding-right: 20px;

}

.author-olivia {
  padding: 20px 0;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .blog1-container {
    flex-direction: column;
    gap: 40px;
  }

  .author {
    flex-direction: column;
    padding: 10px;
    margin: 20px;
    gap: 0;
  }

  .main-content,
  .related-posts {
    flex: none;
    width: 100%;
  }
}
</style>